import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './root-reducer';
import initializeRootSaga from './root-saga';

import { connectGqlApi } from './apis/connect-gql-api';
import { mentorGqlApi } from './apis/mentor-gql-api';
import { pensieveGqlApi } from './apis/pensieve-gql-api';
import { reviewsApi } from './apis/reviews';
import 'app/mentor/queries/enhanced';
import 'app/pensieve/queries/enhanced';

export const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(sagaMiddleware)
      .concat(reviewsApi.middleware)
      .concat(connectGqlApi.middleware)
      .concat(mentorGqlApi.middleware)
      .concat(pensieveGqlApi.middleware),
});

initializeRootSaga();

export type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
